import React, { useState } from "react";
import "./ServiceDetails.css";
import Navbar from "../Navbar/Navbar";
import { Link } from "react-router-dom";
import EmergencyMedicineBanner from "../../assets/about_banner.jpg";
import Img1 from "../../assets/doctors/prasanna_kumar_mishra.png";
import Img3 from "../../assets/doctors/sagar_roy.jpg";
import Img4 from "../../assets/doctors/neethu_nahak.png";
import Img5 from "../../assets/doctors/Dr.-Sayantika.jpg";
import G1 from "../../assets/department photos/emergency1.jpg";
import G2 from "../../assets/department photos/emergency2.png";
import G3 from "../../assets/department photos/emergency3.png";
import G4 from "../../assets/department photos/emergency4.png";
import G5 from "../../assets/department photos/emergency5.png";
import G6 from "../../assets/department photos/emergency6.png";
import G7 from "../../assets/department photos/emergency7.jpg";
import G8 from "../../assets/department photos/emergency8.jpg";
import G9 from "../../assets/department photos/emergency9.jpg";
import G10 from "../../assets/department photos/emergency10.jpg";
import G11 from "../../assets/department photos/emergency11.jpg";
import G12 from "../../assets/department photos/emergency12.jpg";
import G13 from "../../assets/department photos/emergency13.jpg";
import G14 from "../../assets/department photos/emergency14.jpg";

function EmergencyMedicine() {
  const [currentImage, setCurrentImage] = useState("");

  const openModal = (image) => {
    setCurrentImage(image);
    const modalElement = document.getElementById("exampleModal");
    const modal = new window.bootstrap.Modal(modalElement);
    modal.show();
  };

  const slides = [
    {
      image: Img1,
      name: "Dr. Prasanna Kumar Mishra",
      qualification:
        "Prof. & Head Emergency Medicine, MBBS, MD(Anesthesiology)",
      location: "Ashwini Hospital",
    },
    {
      image: Img3,
      name: "Dr. Sagar Roy",
      qualification: "MD(Emergency Medicine)",
      location: "Ashwini Hospital",
    },
    {
      image: Img4,
      name: "Dr. Neethu Sujala Nahak",
      qualification: "Masters in Emergency Medicine",
      location: "Ashwini Hospital",
    },
    {
      image: Img5,
      name: "Dr. Sayantika Sarkar",
      qualification: "Masters in Emergency Medicine",
      location: "Ashwini Trauma Centre",
    },
  ];

  const gallery = [
    { image: G1 },
    { image: G2 },
    { image: G3 },
    { image: G4 },
    { image: G5 },
    { image: G6 },
    { image: G7 },
    { image: G8 },
    { image: G9 },
    { image: G10 },
    { image: G11 },
    { image: G12 },
    { image: G13 },
    { image: G14 },
  ];
  return (
    <>
      <Navbar />

      {/* Emergency Medicine Banner */}
      <section className="page-title text-center">
        <div className="bg-layer">
          <img
            src={EmergencyMedicineBanner}
            alt="Emergency Medicine Banner"
            title="Emergency Medicine Banner"
          />
        </div>
        <div className="container">
          <div className="content-box">
            <ul className="bread-crumb clearfix">
              <li>
                <Link to={"/"}>Home</Link>
              </li>
              <li>
                <Link to={"/Departments"}>Departments</Link>
              </li>
              <li>Emergency Medicine</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Emergency Medicine Doctors */}
      <div className="my-3">
        <div className="container">
          <div className="sec-title">
            <h1>Our Esteemed Consultants</h1>
          </div>

          <div className="row row-cols-1 row-cols-md-4 g-4 justify-content-center">
            {slides.map((slide, index) => (
              <div className="col-lg-3 col-md-4" key={index}>
                <a
                  className="doc-name"
                  href={`/Doctors/${slide.name
                    .replace(/\s+/g, "")
                    .toLowerCase()}`}
                >
                  <div className="card h-100 doctor_img">
                    <img
                      src={slide.image}
                      alt={`${slide.name} Img`}
                      title={slide.name}
                    />
                    <div className="doc-text">
                      <h3>{slide.name}</h3>
                      <p>{slide.qualification}</p>
                      <span className="text-dark">{slide.location}</span>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Section */}
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-12 col-sm-12 mb-3 hero-section">
            {/* gallery */}
            <div className="card">
              <div className="card-body">
                <h2 className="card-title widget-title mb-3">Media</h2>
                <div className="widget-content clearfix">
                  <ul className="image-list">
                    {gallery.map((g, index) => (
                      <li key={index}>
                        <figure>
                          <img
                            src={g.image}
                            alt=" Emergency Medicine Gallery"
                            title="Emergency Medicine Department"
                            onClick={() => openModal(g.image)}
                          />
                        </figure>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {/* Modal */}
            <div
              className="modal fade"
              id="exampleModal"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">
                      Image Preview
                    </h1>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <img
                      src={currentImage}
                      alt="Emergency Medicine Gallery"
                      title="Emergency Medicine Department"
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-8 col-md-12 col-sm-12 mb-3">
            <div className="card">
              <div className="card about-style-two py-0">
                <div className="container card-body">
                  <div className="section-1">
                    <h3 className="sec-title">
                      Emergency Medicine – Ashwini Group of Hospitals
                    </h3>
                    {/* <h5 className="fs-6 fw-bold text-primary">
                      About the Department
                    </h5> */}
                    <p>
                      The Ashwini Group of Hospitals has built a reputation as a
                      regional leader in <strong>Emergency Care</strong>, with <strong>Emergency Medicine</strong>{" "}
                      services forming a cornerstone of its healthcare mission.
                      Our emergency units are known for rapid triage,
                      comprehensive patient assessment, and collaborative
                      management involving multiple specialties.
                    </p>
                    <p>
                      The departments are powered by expert <strong>Emergency
                      Physicians, Critical Care Specialists, Neurosurgeons,
                      Cardiologists, Pulmonologists, and Trauma Surgeons</strong>—working
                      in unison to address a wide range of emergencies such as{" "}
                      <strong>strokes, trauma, cardiac arrests, seizures, poisoning,
                      respiratory distress, AKI, and surgical emergencies.</strong>
                    </p>
                    <p>
                      State-of-the-art facilities including <strong>ER ICUs</strong>, advanced
                      diagnostic tools <strong>(CT/MRI, USG, 2D Echo)</strong>,<strong>emergency
                      dialysis, and 24-hour lab services</strong> are standard across the
                      group. The teams perform critical interventions like{" "}
                      <strong>thrombolysis, mechanical ventilation, and primary PTCA</strong> on
                      a routine basis.
                    </p>
                    <p>
                      Among its flagship centers, Ashwini Hospital, Cuttack has
                      been accredited by <strong>NBEMS for <a href="/Academic/DNB/DNB-Emergency-Medicine" className="text-decoration-none">DNB in Emergency Medicine</a> (02
                      seats annually</strong>) since the Jan/Feb 2023 session,
                      underlining the group’s commitment to medical training and
                      excellence.
                    </p>
                    <p>
                      All centers under the Ashwini are equipped with{" "}
                      <strong>Advanced Cardiac Life Support (ACLS) Ambulances</strong>, ensuring
                      timely transport and pre-hospital stabilization for
                      critically ill patients.{" "}
                    </p>
                    <h3 className="sec-title">Facilities Provided</h3>

                    <ul className="list-group list-group-flush mb-3">
                      <li className="list-group-item list-group-item-primary">
                        Dedicated ER ICU with ventilators
                      </li>
                      <li className="list-group-item list-group-item-secondary">
                        24x7 Emergency Laboratory
                      </li>
                      <li className="list-group-item list-group-item-success">
                        Advanced Radiology Services – CT Scan & MRI
                      </li>
                      <li className="list-group-item list-group-item-info">
                        Bedside Diagnostics – 2D Echo, Ultrasound, ECG, ABG
                      </li>
                      <li className="list-group-item list-group-item-primary">
                        ACLS-equipped Ambulances (2 units)
                      </li>
                    </ul>
                    <h4 className="sec-title">
                      Why Choose Ashwini Hospital’s Emergency Medicine
                      Department?
                    </h4>
                    <ul className="custom-style">
                      <li>
                        <strong>NBEMS-accredited DNB Program:</strong> 2
                        seats/year since Jan/Feb 2023
                      </li>

                      <li>
                        <strong>High Case Load:</strong> Rich exposure to
                        diverse and high-acuity emergencies
                      </li>

                      <li>
                        <strong>Integrated Superspecialty Support:</strong>{" "}
                        Seamless access to Neuro, Cardiac, Pulmonary, and
                        Surgical experts
                      </li>

                      <li>
                        <strong>State-of-the-art Infrastructure:</strong> ER
                        ICU, CT, MRI, emergency dialysis, 24/7 diagnostics
                      </li>

                      <li>
                        <strong>Advanced Ambulance Support:</strong> 2 ACLS
                        ambulances for rapid pre-hospital care
                      </li>
                      <li>
                        <strong>Academic & Skill-based Training: </strong>{" "}
                        Hands-on exposure with emphasis on decision-making and
                        procedures
                      </li>
                      <li>
                        <strong>Commitment to Excellence:</strong> Trusted by
                        patients across Odisha for prompt and ethical emergency
                        care
                      </li>
                    </ul>
                    <h4 className="sec-title">Services Offered</h4>
                    <p>
                      Our Emergency Department is fully equipped to handle a
                      wide range of life-threatening and acute emergencies,
                      including:
                    </p>
                    
                     
                        <ul className="list-group list-group-flush mb-3">
                          <li className="list-group-item list-group-item-primary">
                            Acute Ischemic Brain Stroke (with thrombolysis)
                          </li >
                          <li className="list-group-item list-group-item-secondary">Status Epilepticus</li>
                          <li className="list-group-item list-group-item-info"> 
                            AIDP (Acute Inflammatory Demyelinating
                            Polyneuropathy)
                          </li>
                          <li className="list-group-item list-group-item-primary">Myasthenic Crisis</li>
                          <li className="list-group-item list-group-item-secondary">
                            Acute Myocardial Infarction
                            (AMI)-Thrombolysis,Primary PTCA
                          </li>
                          <li className="list-group-item list-group-item-info">Acute Abdomen and Surgical Emergencies</li>
                          <li className="list-group-item list-group-item-primary">Poisoning and Toxicological Emergencies</li>
                          <li className="list-group-item list-group-item-secondary">Respiratory Failure</li>
                          <li className="list-group-item list-group-item-info">Acute Kidney Injury (Emergency Dialysis)</li>
                          <li className="list-group-item list-group-item-primary">Severe Polytrauma</li>
                          <li className="list-group-item list-group-item-secondary">Obstetric Emergencies from Referral Centers</li>
                        </ul>
                      
                    
                    <h4 className="sec-title">
                      Skills Learned During DNB Training
                    </h4>
                    <p>
                      Residents enrolled in the DNB Emergency Medicine program
                      gain hands-on experience in managing complex emergencies
                      under close mentorship. The training includes:
                    </p>
                    <ul className="custom-style">
                      <li>Prioritization and triage of emergency cases</li>

                      <li>Adult and Pediatric CPR</li>

                      <li>Airway Management & Rapid Sequence Induction</li>

                      <li>Endotracheal Intubation</li>

                      <li>Mechanical Ventilation (Invasive & Non-invasive)</li>
                      <li>Percutaneous and Open Tracheostomy</li>
                      <li>CVP and Arterial Line Monitoring</li>
                      <li>Defibrillation and Cardioversion</li>
                      <li>Hemodialysis Catheter Insertion</li>
                      <li>Lumbar Puncture</li>
                      <li>Bedside Ultrasound / 2D Echo</li>
                      <li>Gastric Lavage and Thoracocentesis</li>
                      <li>ECG and ABG Interpretation</li>
                      <li>Intercostal Tube Drainage (ICTD)</li>
                      <li>Trochar Suprapubic Cystostomy</li>
                      <li>Diagnostic Peritoneal Lavage</li>
                      <li>Management of Rectal Prolapse</li>
                      <li>Manual Reduction of Paraphimosis</li>
                    </ul>
                    {/* <div className="row text-center">
                      {[
                        { image: G2, caption: "Reconstructive Surgery" },
                        { image: G3, caption: "Reconstructive Burn Surgery" },
                        { image: G8, caption: "Complex Wound Coverage" },
                      ].map((facility, index) => (
                        <div key={index} className="col-md-4 mb-4 mt-2">
                          <div className="card h-100 shadow-sm">
                            <img
                              src={facility.image}
                              alt={facility.caption}
                              title={facility.caption}
                              className="img-fluid"
                              style={{ height: "200px", objectFit: "fill" }}
                              onClick={() =>
                                openModal(facility.image, facility.caption)
                              }
                            />
                            <div
                              className="p-2"
                              style={{ backgroundColor: "aliceblue" }}
                            >
                              <h5 className="fs-6 text-primary">
                                {facility.caption}
                              </h5>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EmergencyMedicine;
